import React from 'react';
import {FunctionsOutlined, AttachMoneyOutlined} from '@mui/icons-material';
import {Stack, ToggleButton, ToggleButtonGroup, Tooltip} from '@mui/material';
import {useTranslation} from 'react-i18next';

export const FORMULA_VISIBILITY_MODES = {
    visible: 'visible',
    hidden: 'hidden',
};

const FormulaVisibilityToggle = ({
                                     showFormulas,
                                     onChange,
                                     disabled = false,
                                 }) => {
    const {t} = useTranslation('views', {keyPrefix: 'app-specific.product-prices.formulaVisibility'});

    const value = showFormulas ? FORMULA_VISIBILITY_MODES.visible : FORMULA_VISIBILITY_MODES.hidden;

    return (
        <Stack
            sx={{
                border: '1px solid transparent',
                borderColor: 'divider',
                padding: 0.5,
                borderRadius: 1,
                width: 'fit-content',
                flexShrink: 0,
            }}
        >
            <ToggleButtonGroup
                disabled={disabled}
                size="small"
                exclusive
                value={value}
                onChange={(_, next) => {
                    if (!next) return;
                    onChange(next === FORMULA_VISIBILITY_MODES.visible);
                }}
                sx={{
                    '& .MuiToggleButtonGroup-grouped': {
                        borderRadius: '0.5rem',
                        width: 30,
                        height: 30,
                    },
                    '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
                        marginLeft: '.25rem',
                    },
                }}
            >
                <ToggleButton
                    value={FORMULA_VISIBILITY_MODES.visible}
                    sx={{
                        backgroundColor: showFormulas ? 'divider' : 'transparent',
                        border: 'none',
                    }}
                >
                    <Tooltip title={t('showFormulas')}>
                        <FunctionsOutlined sx={{padding: 0.25}}/>
                    </Tooltip>
                </ToggleButton>
                <ToggleButton
                    value={FORMULA_VISIBILITY_MODES.hidden}
                    sx={{
                        backgroundColor: !showFormulas ? 'divider' : 'transparent',
                        border: 'none',
                    }}
                >
                    <Tooltip title={t('hideFormulas')}>
                        <AttachMoneyOutlined sx={{padding: 0.25}}/>
                    </Tooltip>
                </ToggleButton>
            </ToggleButtonGroup>
        </Stack>
    );
};

export default FormulaVisibilityToggle;
